<template>
  <div class="animated fadeIn">
    <!-- 시스템의 기본 서비스 관리 추가 -->
    <b-card border-variant="primary" id="list">
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> UWSS Base Service
      </template> -->
      <div class="d-flex flex-wrap align-items-center">
        <div class="title mr-auto">
          UWSS Base 서비스
        </div>
      </div>
      <hr>
      <div class="d-flex flex-wrap align-items-center">
        <div class="mr-auto mb7">
          <label class="col-form-label" for="">
            <span class="text-danger">* 새로 생성된 서비스는 시스템이 생성된 후 파트너가 사용할 수 있습니다.</span>
          </label>
        </div>
        <div class="mr-2 mb7">
          <button class="btn btn-sm btn-primary" @click="$refs._list.refresh()">
            새로고침
          </button>
        </div>
        <div class="mr-2 mb7">
          <button type="button" v-if="view_detail != false" class="btn btn-sm btn-addition" tabindex="4" data-toggle="modal" data-target="#System_serevice_info" @click="service_new = true; confirm_info = true; service = {}">
            등록
          </button>
        </div>
      </div>

      <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
        :items="load_service" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk"> <!-- ToDo: 해당 내용 partner 와 동일하게 진행해야합니다. -->
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="is_alive" slot-scope="row">
          <!-- <c-switch @change="status_change($event, row.item, 'is_alive')" color="warning" label v-model="row.item.status" /> -->
          <div class="checkbox-switch">
            <input type="checkbox" @change="status_change($event, row.item, 'is_alive')" class="input-checkbox" name="switch01" id="switch01" checked="" v-model="row.item.status">
            <div class="checkbox-animate">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </template>
        <template slot="name" slot-scope="row">
          <b-btn @click="status_change(row.item, row.item, 'is_del')" variant="outline-danger" size="sm">삭제</b-btn>
          {{row.item.name}}
        </template>
        <template slot="list_price" slot-scope="row">{{row.item.list_price | dollar}}</template>
        <template slot="min_price" slot-scope="row">{{row.item.min_price | dollar}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" class="btn btn-sm btn-insert" tabindex="4">선택</b-btn>
        </template>
      </b-table>
    </b-card>

    <!-- 기존 파트너의 가격 수정 여부 확인 모달 -->
    <b-modal hide-footer title="시스템 서비스 가격 수정"  class="modal-warning" v-model="confirm_all">
      내 기존 파트너에게 새 가격을 적용하고 싶습니까?
      "가격만 업데이트"를 누르면 적용 후 생성된 계정은 업데이트된 가격의 영향을 받습니다.
      <b-button class="mt-3" variant="outline-warning" block @click="confirm_all = false; upsert_service()">가격만 업데이트.</b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="service.apply_all = true; upsert_service()">가격 적용</b-button>
    </b-modal>
    <!-- 미사용 확인 모달 -->
    <b-modal title="시스템 업데이트 안내"  class="modal-danger" v-model="confirm_save" @ok="confirm_refresh = true" ok-variant="danger">
      이 정보를 업데이트하시겠습니까?
    </b-modal>
    <!-- 미사용 확인 모달 -->
    <b-modal :title="`시스템 서비스 ${service.is_alive ? '활성화' : '비활성화'}`"  class="modal-warning" v-model="confirm_toggle" hide-footer ok-variant="warning">
      정말 서비스를 {{service.is_alive ? "활성화" : "비활성화"}} 하시겠습니까?
      <hr>
      <b-button variant="warning" block @click="toggle_service">확인</b-button>
      <b-button variant="primary" block @click="cancel">취소</b-button>
    </b-modal>
    <!-- 삭제 확인 모달 -->
    <b-modal title="시스템 서비스 삭제"  class="modal-danger" v-model="confirm_delete" @ok="delete_service" ok-variant="danger">
      서비스를 삭제하시겠습니까?
    </b-modal>
    <!-- 해당 시스템의 서비스 모달 시작 -->
    <b-modal class="modal-dialog modal-lg modal-dialog-centered" hide-footer title="시스템 서비스 안내" v-model="confirm_info" @ok="confirm_info = false" ok-only ok-variant="info">
      <div class="modal-content">
      <b-row class="mb-2">
        <b-col class="col-form-label" for="Invoice_ID"> <label for="service_name">서비스명 :</label> </b-col>
        <b-col class="col-xl-9 col-md-12">
          <b-input-group prepend="#">
            <b-input class="form-control" id="service_name" placeholder="typing service name" v-model="service.name" :dsiable="lock"></b-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="col-form-label" for="Invoice_ID"> <label class="text-danger font-weight-bold" for="service_cost_price">비용 :</label> </b-col>
        <b-col class="col-xl-9 col-md-12">
          <b-input-group prepend="$">
            <b-input class="form-control" type='number' id="service_cost_price" placeholder="typing cost price" v-model="service.min_price" :dsiable="lock"></b-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="col-form-label" for="Invoice_ID"> <label class="text-warning font-weight-bold" for="public_price">공시 가격 :</label> </b-col>
        <b-col class="col-xl-9 col-md-12">
          <b-input-group prepend="$">
            <b-input class="form-control" type='number' id="public_price" placeholder="typing public price" v-model="service.list_price" :dsiable="lock"></b-input>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="col-form-label" for="Started_at"> <label class="text-info font-weight-bold" for="public_price">대상 도메인 :</label> </b-col>
        <b-col class="col-xl-9 col-md-12">
          <b-input class="m-1" type='number' id="public_price" placeholder="typing target domain" v-model="service.target_domain" :dsiable="lock"></b-input>
        </b-col>
        <b-col class="col-xl-12 col-md-12 d-flex align-self-center"><span>* 예시) 판매대상 도메인이 5+이면 -5, 아니면 1~4이면 4 </span></b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="col-form-label" for="Paid_Amount"> <label for="service_wmds_site">WMDS :</label> </b-col>
        <b-col class="col-xl-3 col-md-12">
          <c-switch id="service_wmds_site" color="info" label v-model="service.use_wmds" />
        </b-col>
        <b-col class="col-form-label" for="Include_VAT"> <label for="service_wmds_analysis">분석 :</label> </b-col>
        <b-col class="col-xl-3 col-md-12 d-flex align-self-center">
          <c-switch id="service_wmds_analysis" color="info" label v-model="service.use_wmds_analysis" />
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col class="col-form-label" for="Paid_Amount"> <label for="service_wmds_page">최대 페이지 :</label> </b-col>
        <b-col class="col-xl-3 col-md-12">
          <b-input id="service_wmds_page" placeholder="Number" v-model="service.wmds_page" :dsiable="lock"></b-input>
        </b-col>
        <b-col class="col-form-label" for="Include_VAT"> <label for="service_wmds_total">페이지(개월) :</label> </b-col>
        <b-col class="col-xl-3 col-md-12 d-flex align-self-center">
          <b-input id="service_wmds_total" placeholder="Number" v-model="service.wmds_total" :dsiable="lock"></b-input>
        </b-col>
      </b-row>
      <br>
      <b-col class="col-xl-12 col-md-12 d-flex align-self-center">
         * 최대 페이지 : 사이트 스캔에 사용되는 최대 페이지 수
         <br>
         * 페이지(개월) : 한 달 동안 wmds 총계 입력
      </b-col>
      <hr>
      <b-row>
        <b-col class="col-form-label" for="Paid_Amount"> <label for="service_waf">WAF :</label> </b-col>
        <b-col lass="col-xl-3 col-md-12">
          <c-switch id="service_waf" color="info" label v-model="service.use_waf" />
        </b-col>
        <b-col class="col-form-label" for="Include_VAT"> <label for="service_waf_doamin">도메인 :</label> </b-col>
        <b-col class="col-xl-3 col-md-12 d-flex align-self-center">
          <b-input id="service_waf_doamin" placeholder="Limit" v-model="service.waf_domain" :dsiable="lock"></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="col-form-label" for="Paid_Amount"> <label for="service_wmds_wsfinder">WSFinder :</label> </b-col>
        <b-col class="col-xl-3 col-md-12">
          <c-switch id="service_wmds_wsfinder" color="info" label v-model="service.use_wsfinder" />
        </b-col>
        <b-col class="col-form-label" for="Include_VAT"> <label for="service_wsfinder_analysis">분석 :</label> </b-col>
        <b-col class="col-xl-3 col-md-12 d-flex align-self-center">
          <c-switch id="service_wsfinder_analysis" color="info" label v-model="service.use_wsfinder_analysis" />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="col-form-label" for="Paid_Amount"> <label for="service_wmds_integrity">진실성 :</label> </b-col>
        <b-col class="col-xl-3 col-md-12">
          <c-switch id="service_wmds_integrity" color="info" label v-model="service.use_integrity" />
        </b-col>

        <b-col class="col-form-label" for="Include_VAT"> <label for="service_is_alive">상태 :</label> </b-col>
        <b-col class="col-xl-3 col-md-12 d-flex align-self-center">
          <c-switch id="service_is_alive" color="info" label v-model="service.is_alive" />
        </b-col>
      </b-row>
      <hr>
      <div class="d-flex flex-wrap">
        <div class="title mr-auto">
          서포트
        </div>
      </div>
      <hr>
      <b-row>
        <b-col class="col-form-label" for="Paid_Amount"> <label for="dedicated_support">전담 지원 :</label> </b-col>
        <b-col class="col-xl-3 col-md-12">
          <c-switch id="dedicated_support" color="info" label v-model="service.use_technical_support" />
        </b-col>
        <b-col class="col-form-label" for="Include_VAT"> <label for="install_support">설치 :</label> </b-col>
        <b-col class="col-xl-3 col-md-12 d-flex align-self-center">
          <c-switch id="install_support" color="info" label v-model="service.use_install_support" />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-form-label" for="Paid_Amount"> <label for="policy_support">정책 :</label> </b-col>
        <b-col class="col-xl-3 col-md-12">
          <c-switch id="policy_support" color="info" label v-model="service.use_policy_support" />
        </b-col>
        <b-col class="col-form-label" for="Include_VAT"> <label for="phone_support">핸드폰 :</label> </b-col>
        <b-col class="col-xl-3 col-md-12 d-flex align-self-center">
          <c-switch id="phone_support" color="info" label v-model="service.use_phone_support" />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="col-form-label" for="Invoice_ID"> <label for="email_support">이메일 :</label> </b-col>
        <b-col class="col-xl-9 col-md-12 d-flex align-self-center">
          <b-form-input type='number' id="email_support" placeholder="" v-model="service.email_support" :dsiable="lock"></b-form-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="col-form-label" for="Invoice_ID"> <label for="service_description">설명 :</label> </b-col>
        <b-col class="col-xl-9 col-md-12 d-flex align-self-center">
          <b-form-textarea id="service_description" placeholder="설명을 입력하세요" v-model="service.description" :dsiable="lock"></b-form-textarea>
        </b-col>
      </b-row>
      <hr>
      <b-button class="mt-3" variant="outline-info" block @click="confirm_all = true">
        {{service_new ? '저장' : '업데이트'}}
      </b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="confirm_info = false">닫기</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>